import Chart from "react-apexcharts";
import { Card, CardBody } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import crudApi from "@serie3/common/api/crudApi";
import DashboardEndpoints from "@serie3/mymediaplanner/Modules/Dashboard/endpoints";
import getDashboardUrl from "@serie3/mymediaplanner/Modules/Dashboard/Domain/getDashboardUrl";

const FollowerGrowth = ({ monthYear }) => {
  const { t } = useTranslation();
  const [linkedin, setLinkedin] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      const url = getDashboardUrl(DashboardEndpoints.stats, monthYear);
      const response = await crudApi.justGet(url);
      if (response?.ok) {
        setLinkedin(response.data.followerGrowth?.linkedin ?? []);
      }
    };
    fetch();
  }, [monthYear]);

  if (linkedin.length === 0) return null;

  const categories = linkedin.map((d) => d.date);
  const counts = linkedin.map((d) => d.followerCount);

  const options = {
    chart: {
      id: "follower-growth",
      toolbar: { show: false },
      fontFamily: "Montserrat, sans-serif",
      dropShadow: { enabled: true, top: 4, left: 0, blur: 6, opacity: 0.08 },
    },
    colors: ["#038edc"],
    stroke: { curve: "straight", width: 3 },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.3,
        opacityTo: 0.02,
        stops: [0, 100],
      },
    },
    markers: { size: 5, colors: ["#038edc"], strokeWidth: 0, hover: { size: 7 } },
    dataLabels: { enabled: false },
    grid: {
      borderColor: "#f0f2f5",
      strokeDashArray: 4,
      xaxis: { lines: { show: false } },
    },
    xaxis: {
      categories,
      labels: { style: { fontSize: "11px", fontWeight: 600, colors: "#9299a8" } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: { fontSize: "11px", colors: "#9299a8" },
        formatter: (v) => Math.round(v).toLocaleString(),
      },
      min: Math.min(...counts) - 20,
    },
    tooltip: {
      theme: "light",
      style: { fontSize: "12px" },
      y: { formatter: (v) => v.toLocaleString() },
    },
    legend: { show: false },
  };

  const series = [{ name: t("Backend.Dashboard.FollowerGrowth.Followers", "Followers"), data: counts }];
  const growth = counts.length >= 2 ? counts[counts.length - 1] - counts[0] : 0;
  const growthColor = growth >= 0 ? "#51d28c" : "#f34e4e";

  return (
    <Card style={{ borderRadius: 16, border: "1px solid #eaecf0", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", height: "100%" }}>
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <h4 className="page-section-header" style={{ marginBottom: 0 }}>
            <span className="page-section-header-icon" style={{ background: "rgba(81,210,140,0.12)" }}>
              <FontAwesomeIcon icon={faUserPlus} style={{ color: "#51d28c" }} />
            </span>
            {t("Backend.Dashboard.FollowerGrowth.Title", "Follower Growth")}
          </h4>
          <span style={{ fontSize: 12, fontWeight: 700, color: growthColor }}>
            {growth >= 0 ? "+" : ""}{growth.toLocaleString()}
          </span>
        </div>
        <p style={{ fontSize: 12, color: "#9299a8", marginBottom: 16, marginLeft: 44 }}>
          LinkedIn · {counts[counts.length - 1]?.toLocaleString()} {t("Backend.Dashboard.FollowerGrowth.Total", "total followers")}
        </p>
        <Chart options={options} series={series} type="area" height="180" />
      </CardBody>
    </Card>
  );
};

export default FollowerGrowth;
